













































/**
 * https://www.digitalocean.com/community/tutorials/vuejs-vue-modal-component
 */

import { Vue, Component } from "vue-property-decorator";
@Component
export default class NoteModal extends Vue {
  protected close(): void {
    this.$emit("close");
  }
}
